import { gqlClient } from '@/api/graphql-client';
import projectKeys from '@/api/queries/project/keyFactory';
import { graphql } from '@/gql';
import {
  SendEstimateInput,
  SendEstimateMutation as SendEstimateMutationResult,
} from '@/gql/graphql';
import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

const SendEstimateMutation = graphql(`
  mutation SendEstimate($input: SendEstimateInput!) {
    sendEstimate(input: $input) {
      id
    }
  }
`);

const useSendEstimate = (args: {
  projectId: string;
  options?: UseMutationOptions<
    SendEstimateMutationResult,
    Error,
    SendEstimateInput
  >;
}) => {
  const { projectId } = args;
  const queryClient = useQueryClient();
  const { onSuccess, ...restOptions } = args.options ?? {};

  return useMutation({
    mutationFn: (input: SendEstimateInput) => {
      return gqlClient.request(SendEstimateMutation, { input });
    },
    onSuccess: (data, variables, context) => {
      // Refetching the project estimates picks up the new SENT status and the
      // frozen `sentDocumentHtml`, so the preview pane switches from the live
      // preview to the stored snapshot.
      void queryClient.invalidateQueries({
        queryKey: projectKeys.estimates(projectId),
      });
      onSuccess?.(data, variables, context);
    },
    ...restOptions,
  });
};

export default useSendEstimate;
